import React, { useEffect } from 'react'
import classNames from 'classnames'

import { CheckBox, Input } from '@st-operations/uikit/src/v2/index.js'

import MultiValueInput from '_components/multi-value-input'
import RadioGroup from '_components/radio-input-group'
import Select from '_components/select'

import {
  COUNTRIES_OPTIONS,
  DESTINATION,
  DESTINATION_TITLES,
  LOOKBACK_OPTIONS,
  OMM_STATUS_OPTIONS,
  SCHEMA,
} from '../constants'
import { filterKeywordBasedOnBrand } from '../create-media-measurement-campaign-modal'

import './styles.scss'

const findRegion = (regionCode) => COUNTRIES_OPTIONS.find(({ value }) => value.includes(regionCode))

const AudienceSettings = ({ data, updateState, updateReports, status }) => {
  const region = findRegion(
    data[SCHEMA.COUNTRIES]?.[0] ?? data[SCHEMA.COUNTRIES]?.value?.[0] ?? 'all'
  )
  const isEditable = status === OMM_STATUS_OPTIONS.DRAFT

  useEffect(() => {
    filterKeywordBasedOnBrand(data, updateState(SCHEMA.PRODUCT_NAMES))
  }, [data])

  const updateCountries = (value) => updateState(SCHEMA.COUNTRIES)(value?.value || [])

  return (
    <div className="tab-audience-settings">
      <div className="tab-audience-settings__header">
        <h3 className="tab-audience-settings__header-title">Audience Settings</h3>
      </div>
      <div
        className={classNames('tab-audience-settings__content', {
          'tab-audience-settings__content--disabled': !isEditable,
        })}
      >
        <div>
          <Input
            label="Audience Name"
            name={SCHEMA.NAME}
            onChange={updateState(SCHEMA.NAME)}
            disabled={!isEditable}
            value={data[SCHEMA.NAME]}
            placeholder="Ex. Nike Basketball Shoes"
          />
          <Input
            label="Campaign Objective"
            name={SCHEMA.CAMPAIGN_OBJECTIVE}
            onChange={updateState(SCHEMA.CAMPAIGN_OBJECTIVE)}
            disabled={!isEditable}
            value={data[SCHEMA.CAMPAIGN_OBJECTIVE]}
            placeholder="Ex. Nike Basketball Shoes"
          />
          <Select
            label="Regions"
            name={SCHEMA.COUNTRIES}
            options={COUNTRIES_OPTIONS}
            onChange={updateCountries}
            isDisabled={!isEditable}
            value={region}
            useReactSelect
          />
          <Input
            label="Brand Mentions"
            name={SCHEMA.BRAND_NAME}
            onChange={updateState(SCHEMA.BRAND_NAME)}
            disabled={!isEditable}
            value={data[SCHEMA.BRAND_NAME]}
            containerStyle={{ marginTop: 20 }}
            placeholder="Ex. NIKE"
          />
          <MultiValueInput
            label="Keywords for Contextual Expansion"
            values={data[SCHEMA.PRODUCT_NAMES]}
            onChange={updateState(SCHEMA.PRODUCT_NAMES)}
            disabled={!isEditable}
          />
          <If condition={data[SCHEMA.BRAND_NAME] && data[SCHEMA.PRODUCT_NAMES].length}>
            <div className="tab-audience-settings__note">
              {data[SCHEMA.PRODUCT_NAMES].map((keyword, index) => (
                <div>{`${data[SCHEMA.BRAND_NAME]} AND ${keyword} ${
                  data[SCHEMA.PRODUCT_NAMES].length - 1 !== index ? 'OR' : ''
                }`}</div>
              ))}
            </div>
          </If>
          <p
            className={classNames({ 'tab-audience-settings__label--disabled': !isEditable })}
            style={{ marginTop: 20 }}
          >
            Look Back Window
          </p>
          <RadioGroup
            className={'flex flex-row gap-8'}
            options={LOOKBACK_OPTIONS.map((option) => ({
              label: option,
              checked:
                data[SCHEMA.LOOKBACK]?.toLowerCase().replaceAll(' ', '_') ===
                option?.toLowerCase().replaceAll(' ', '_'),
              disabled: !isEditable,
            }))}
            onChange={(event) =>
              updateState(SCHEMA.LOOKBACK)(event.target.value?.toLowerCase().replaceAll(' ', '_'))
            }
          />
          <p className={classNames({ 'tab-audience-settings__label--disabled': !isEditable })}>
            Delivery Destination
          </p>
          <RadioGroup
            className={'flex flex-row gap-8'}
            groupName="Destination"
            options={Object.values(DESTINATION).map((dest) => ({
              label: dest,
              checked: data[SCHEMA.DELIVERY_DESTINATION] === dest,
              disabled: !isEditable || !region.destinationOptions.includes(dest),
              title: DESTINATION_TITLES[dest],
            }))}
            onChange={(event) => updateState(SCHEMA.DELIVERY_DESTINATION)(event.target.value)}
          />
        </div>
        <div>
          <MultiValueInput
            label="Reference URLs"
            values={data[SCHEMA.URLS]}
            onChange={updateState(SCHEMA.URLS)}
            disabled={!isEditable}
          />
          {/* <div
            className={classNames('tab-audience-settings__reports', {
              'tab-audience-settings__reports--disabled': !isEditable,
            })}
          >
            <p>Reports</p>
            <CheckBox
              label="Demographic Report"
              checked={data?.reports?.demographic?.selected ?? false}
              onChange={(e) => updateReports('demographic')(e.target.checked)}
              disabled={!isEditable}
            />
            <CheckBox
              label="Audience Trend Report"
              checked={data?.reports?.audienceTrend?.selected ?? false}
              onChange={(e) => updateReports('audienceTrend')(e.target.checked)}
              disabled={!isEditable}
            />
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default AudienceSettings
